import { render, staticRenderFns } from "./TabsModule.vue?vue&type=template&id=b0fc8556"
import script from "./TabsModule.vue?vue&type=script&lang=js"
export * from "./TabsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports